import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { ToastController, ToastOptions } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { has, isUndefined } from 'lodash-es';
import { filter } from 'rxjs/operators';

import { TooltipEnum } from '../../enums/tooltip';
import * as fromSettingSelectors from '../../store/selectors/setting.selectors';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private router = inject(Router);
  private store = inject(Store);
  private toastController = inject(ToastController);

  private enableTooltips = true;

  private queue: {
    [key: string]: ToastOptions;
  } = {};

  constructor() {
    this.store.pipe(select(fromSettingSelectors.selectEnableTooltips)).subscribe((enableTooltips) => {
      this.enableTooltips = enableTooltips;
    });

    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(() => this.dismissAll());
  }

  async show(options: ToastOptions, key: TooltipEnum) {
    let tooltip: HTMLIonToastElement | null = null;

    if (this.enableTooltips && !has(this.queue, key)) {
      await this.dismissAll();

      this.queue[key] = options;

      tooltip = await this.toastController.create({
        swipeGesture: 'vertical',
        ...options
      });
      await tooltip?.present();

      tooltip?.onDidDismiss().then(() => {
        delete this.queue[key];
      });
    }

    return tooltip;
  }

  async dismissAll() {
    let activeTooltip = await this.toastController.getTop();

    while (!isUndefined(activeTooltip)) {
      await activeTooltip.dismiss();
      activeTooltip = await this.toastController.getTop();
    }
  }
}
